<template>
  <IconListItem icon="orders" :label="$t('myorders.listitem.plays.label', 1)">
    {{ translatedPlays }}
  </IconListItem>
</template>

<script lang="ts" setup>
import type {
  HighFrequency_AddOn,
  HighFrequency_GameId,
  LotteryId,
  Money,
} from '#api/shared/@types/generated/backend/graphql-schema-types'

import IconListItem from '~/components/IconList/IconListItem.vue'

type MyOrdersListItemGameProps = {
  addOns: HighFrequency_AddOn[]
  lotteryId: HighFrequency_GameId | LotteryId
  spots: number
  wager: Money
}

const { addOns, lotteryId, spots, wager } = defineProps<MyOrdersListItemGameProps>()

const { t } = useI18n()

const translatedPlays = computed(() => {
  const values = [t('myorders.listitem.games.spots.value', { spots })]

  values.push(`, ${t('myorders.listitem.games.wager.value', { wager: wager.value / 100 })}`)

  if (addOns.length) {
    values.push(
      ...addOns.map((addOn) =>
        addOn.value === 'true'
          ? ` + ${t(`lottery.${lotteryId.toLowerCase()}.${addOn.name.toLowerCase()}`)}`
          : '',
      ),
    )
  }

  return values.join('')
})
</script>
